import React, {useContext, useEffect, useState} from "react";
import { CollectionsDashboard as DashBoardV1 } from "./components/organisms/CollectionsDashboard";
import WorkItemTable from "./components/organisms/workItemsTable";
import WorklistSettings from "./components/organisms/CollectionSettings";
import { ProfileForm } from "./components/organisms/ProfileForm";
import { QARuleForm } from "./components/organisms/QARuleForm";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {policiesContext, WidgetConstants} from "./utils/common";
import {Alert, Box, Grid, IconButton, Snackbar} from "@mui/material";
import gear from "../public/assets/icons/gear.svg";
import CodingQuality from "./components/wrappers/CodingQuality";
import Worklist from "./components/wrappers/Worklist";
import {SnackbarContext} from "./context/AlertsContext";
import QualityAssessment from "./components/wrappers/QualityAssessment";
import QueueSettings from "./components/wrappers/QueueSettings";

function App({ widgetName, client, widgetOptions }) {
  const [directoryType, setDirectoryType] = useState(undefined);
  const {snackbarOpen, snackBarMessage, snackBarStatus, closeSnackbar} = useContext(SnackbarContext);
  const { roles } = React.useContext(policiesContext);
  useEffect(() => {
    switch (widgetName) {
      case "GRID_WIDGET_CASES":
        setDirectoryType("workitem");
        break;
      case "GRID_WIDGET_WORKLIST_SETTINGS":
        setDirectoryType("collection");
        break;
      case "GRID_CODING_QUALITY":
        setDirectoryType("workitem");
        break;
      case "GRID_QUALITY_ASSESSMENT":
        setDirectoryType("workitem");
        break;
      default:
        break;
    }
  }, [widgetName]);

  return (
      <>
        {/* @ts-ignore */}
        <Router>
          {/* @ts-ignore */}
          <Route path="/cmx/worklist">
              <Worklist
                  client={client}
                  widgetOptions={widgetOptions}
                  directoryType={directoryType}
              />
          </Route>
          {/* @ts-ignore */}
          <Route path="/cmx/queue-settings">
              <QueueSettings
                  client={client}
                  widgetOptions={widgetOptions}
                  directoryType={directoryType}
                  setDirectoryType={setDirectoryType}
              />
          </Route>
          {/* @ts-ignore */}
          <Route path="/cmx/coding-quality">
              <CodingQuality
                  client={client}
                  widgetOptions={widgetOptions}
                  directoryType={directoryType}
              />
          </Route>
          {roles.includes("cqa_manager") || roles.includes("cqa_coder") ? (
              // @ts-ignore
              <Route path="/cmx/quality-assessment">
                <QualityAssessment
                    client={client}
                    widgetOptions={widgetOptions}
                    directoryType={directoryType}
                />
              </Route>
          ) : null}
        </Router>

        <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={snackbarOpen}
            onClose={closeSnackbar}
            sx={{marginLeft: "100px"}}
        >
          <Alert severity={snackBarStatus} sx={{ width: "100%" }}>
            {snackBarMessage}
          </Alert>
        </Snackbar>
      </>
  );
}

export default App;
